// imported in base router.ts
export default
	[{
		path: "/tests/partnertest/",
		name: "partnertest",
		component: () => import("@/tests/partner/partner.vue"),
		props: true,
		children: [],
		meta: { name: "PartnerTest", page: "" }
	},
	];
